'use es6';

import partial from 'react-utils/partial';
export default {
  partial: partial
};